<script>
  import { onMount } from "svelte"
  import notify from "../../../../../Script/notify"
  import BadgeState from "../../Stores/badgeState"
  export let singleBox = {}
  export let active

  let WIDTH_AREA = 100
  let HEIGHT_AREA = 83.33

  onMount(() => {
    try {
      let arr = singleBox.split(" X ")
      let dimensionWidth = Number(arr[0])
      let dimensionHeight = Number(arr[1])

      if (dimensionWidth > dimensionHeight) HEIGHT_AREA = (WIDTH_AREA * dimensionHeight) / dimensionWidth
      else WIDTH_AREA = (dimensionWidth * HEIGHT_AREA) / dimensionHeight
    } catch (error) {
      const info = "PAGE: Badge Design Editor (Box Model)\nEVENT: onMount"
      notify.danger(error, info)
      console.error(error)
    }
  })
</script>

<div class="flex flex-col items-center justify-center p-1">
  <button type="button" on:click class="flex h-32 w-32 flex-col items-center justify-center rounded-md border-4 bg-gray-a00 hover:border-extraBlue-500 {active == singleBox ? 'border-green-500' : 'border-transparent'} ">
    <div style="width: {WIDTH_AREA}px;height:{HEIGHT_AREA}px;background:{$BadgeState.canvasColor == 'transparent' ? 'url("assets/img/grid.png")' : `${$BadgeState.canvasColor}`};" class="rounded" />
  </button>
  <h1 class="mt-2 text-base font-semibold text-[#E7E4D5]">{singleBox}</h1>
</div>
